module.exports = __webpack_public_path__ + "static/media/foot.9d78cd6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pet_icons/foot.svg
// module id = 60
// module chunks = 0